import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import './EmailVerification.css';

const EmailVerification = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      console.log('EmailVerification component mounted');
      console.log('Token from URL:', token);
      
      if (!token) {
        console.log('No token found in URL');
        setStatus('error');
        setError('Verification token is missing from the URL');
        return;
      }

      try {
        console.log('Making API call to verify email with token:', token);
        const response = await api.get(`/email-verification/verify/${token}`);
        const data = response.data;
        console.log('Response data:', data);

        if (data.success) {
          setStatus('success');
          setMessage(data.message || 'Email verified successfully!');
          
          // Redirect to login after 3 seconds
          setTimeout(() => {
            navigate('/login', { 
              state: { 
                message: 'Email verified successfully! You can now log in.',
                type: 'success'
              }
            });
          }, 3000);
        } else {
          setStatus('error');
          setError(data.message || 'Email verification failed. Please try again.');
        }
      } catch (err) {
        console.error('Verification error:', err);
        setStatus('error');
        setError('Network error occurred. Please check your connection and try again.');
      }
    };

    verifyEmail();
  }, [token, navigate]);

  const handleResendEmail = async () => {
    try {
      // We'll need the user's email - for now, just redirect to login
      navigate('/login', { 
        state: { 
          message: 'Please log in to resend verification email.',
          type: 'info'
        }
      });
    } catch (err) {
      console.error('Resend error:', err);
    }
  };

  return (
    <div className="email-verification-container">
      <div className="verification-card">
        <div className="verification-header">
          <h1>🐰 White Rabbit</h1>
          <h2>Email Verification</h2>
        </div>

        <div className="verification-content">
          {status === 'verifying' && (
            <div className="verification-status verifying">
              <div className="loading-spinner"></div>
              <h3>Verifying Your Email...</h3>
              <p>Please wait while we verify your email address.</p>
            </div>
          )}

          {status === 'success' && (
            <div className="verification-status success">
              <div className="success-icon">✅</div>
              <h3>Email Verified Successfully!</h3>
              <p>{message}</p>
              <p className="redirect-info">Redirecting you to login in 3 seconds...</p>
              <Link to="/login" className="login-button">
                Go to Login Now
              </Link>
            </div>
          )}

          {status === 'error' && (
            <div className="verification-status error">
              <div className="error-icon">❌</div>
              <h3>Verification Failed</h3>
              <p className="error-message">{error}</p>
              
              <div className="error-actions">
                <Link to="/login" className="login-button">
                  Go to Login
                </Link>
                <button onClick={handleResendEmail} className="resend-button">
                  Request New Verification
                </button>
              </div>
              
              <div className="help-text">
                <h4>Common Issues:</h4>
                <ul>
                  <li>The verification link may have expired (valid for 48 hours)</li>
                  <li>The link may have been used already</li>
                  <li>Check if the full link was copied correctly</li>
                </ul>
              </div>
            </div>
          )}
        </div>

        <div className="verification-footer">
          <p>Having trouble? Contact support at support@whiterabbit.icu</p>
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;